import {Component, inject, OnInit, Signal} from '@angular/core'
import {RouterOutlet} from '@angular/router'
import {NavbarComponent} from '../shared/components/navbar/navbar.component'
import {MatDrawerContainer, MatDrawerContent} from '@angular/material/sidenav'
import {FullscreenLoaderComponent} from '../shared/components/fullscreen-loader/fullscreen-loader.component'
import {FullscreenLoaderService} from '../shared/components/fullscreen-loader/fullscreen-loader.service'

@Component({
    selector: 'app-unprotected-layout',
    standalone: true,
    imports: [RouterOutlet, MatDrawerContainer, MatDrawerContent, NavbarComponent, FullscreenLoaderComponent],
    template: `
        <div class="app-layout-container">
            <app-navbar [useWithAuth]="false" />
            <mat-drawer-container autosize="true">
                <mat-drawer-content #drawerContent>
                    <div class="sidenav-scroll-wrapper">
                        <router-outlet />
                    </div>
                </mat-drawer-content>
            </mat-drawer-container>
        </div>
        @if (loaderState()) {
            <app-fullscreen-loader></app-fullscreen-loader>
        }
    `
})
export class UnprotectedLayoutComponent implements OnInit {
    private fullscreenLoaderService = inject(FullscreenLoaderService)
    loaderState: Signal<boolean>

    ngOnInit() {
        this.loaderState = this.fullscreenLoaderService.getState()
    }
}
